import React from 'react';

import { useApp } from '../../../store/AppContext';
import { BORDER, BORDER_DARK, cell, dayHeaderHeight, MONTH_H, WEEK_H } from '../shared/style';

/* Coin fixe de l'en-tête, au-dessus de la colonne de noms (une case par ligne d'en-tête). */
export default function HeaderCorner() {
  const { timelineZoom } = useApp();
  const corner = { background: '#fff', borderRight: BORDER };
  return (
    <>
      <div style={cell({ ...corner, borderBottom: BORDER, height: MONTH_H })} />
      <div style={cell({ ...corner, borderBottom: BORDER, height: WEEK_H })} />
      <div
        style={cell({
          ...corner,
          borderBottom: BORDER_DARK,
          height: dayHeaderHeight(timelineZoom),
        })}
      />
    </>
  );
}
